import { useState, useEffect, SetStateAction } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import {
  City,
  Role,
  RoleStatusCandidateCount,
  RoleValidationConfig,
} from "../../Models";
import RoleCandidates from "./RoleCandidates/RoleCandidates";
import { useNotification } from "../../context/NotificationContext";
import useApiToken from "../../hooks/useApiToken";
import "react-datepicker/dist/react-datepicker.css";
import {
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
  ChevronDoubleUpIcon,
} from "@heroicons/react/20/solid";
import RoleSidebarCandidate from "./Sidebar/RoleSidebarCandidate";
import RightSidebar from "./Sidebar/RightSidebar";

import RoleSideBarEdit from "./Sidebar/RoleSidebarEdit";
import RoleSideBarHeader from "./Sidebar/RoleSidebarHeader";
import { NIL } from "uuid";
import CreateRole from "./CreateRole/CreateRole";
import SlotModal from "./Sidebar/CreatSlots";
import InterviewSlotShow from "./Sidebar/InterviewSlots";
import RoleValidationConfigModal from "./Modals/RoleConfigModal";
import { createSlots, GetRole, GetRoleValidationConfig, GetStatusForRole, UpsertRoleValidationConfig } from "../../api/roles.api";
import { getRankType } from "../../api/ranking.api";
import { GetCities } from "../../api/masterdata.api";
const tabs = ["Candidates", "Edit"];
export const initialRankType = { id: NIL, name: "Overall" };

export default function RolePage() {
  const [status, setStatus] = useState<RoleStatusCandidateCount>({
    roleStatuses: [],
    totalCandidateCount: 0,
  });
  const [role, setRole] = useState<Role>();
  const [cities, setCities] = useState<City[]>([]);

  const [filterQuery, setFilterQuery] = useState("");
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [rightfilter, setrightfilter] = useState("");

  const [leftfilter, setleftfilter] = useState("");

  const [isSidebarOpen, setIsSideBarOpen] = useState(true);
  const [scrollToTop, setScrollToTop] = useState(false);
  const [currentTab, setCurrentTab] = useState("Candidates");
  const { info, success, error: notifyError } = useNotification();
  const [statusFilterIsAll, setStatusFilterIsAll] = useState(true);

  const [rankType, setRankType] = useState(initialRankType);

  const [selectedColumns, setSelectedColumns] = useState<any>([]);
  const [isRightSidebarOpen, setIsRightSideBarOpen] = useState(false);
  // Opened from the right sidebar, but the modal itself lives with the candidate grid it filters.
  const [importEmailListOpen, setImportEmailListOpen] = useState(false);

  const token = useApiToken();
  const { roleId } = useParams<{ roleId: string }>();
  const location = useLocation();
  const [isCreateSlotOpen, setIsCreateSlotOpen] = useState(false);
  const [isShowSlotOpen, setIsShowSlotOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [openConfigModal, setOpenConfigModal] = useState<boolean>(false);
  const [config, setConfig] = useState<RoleValidationConfig | null>(null);
  useEffect(() => {
    var addd = leftfilter + rightfilter;
    setFilterQuery(addd);
  }, [rightfilter, leftfilter]);
  useEffect(() => {
    const load = async () => {
      if (!token || !role?.id) return;
      const cfg = await GetRoleValidationConfig(role.id, token);
      setConfig({
        id: cfg.id,
        roleId: role.id,
        ugMinStartAge: cfg.ugMinStartAge ?? null,
        ugFirstMaxStartAge: cfg.ugFirstMaxStartAge ?? null,
        ugMinDurationYears: cfg.ugMinDurationYears ?? null,
        ugMaxDurationYears: cfg.ugMaxDurationYears ?? null,
        pgMaxDurationYears: cfg.pgMaxDurationYears ?? null,
        workMaxStartAge: cfg.workMaxStartAge ?? null,
        maxGapYears: cfg.maxGapYears ?? null,
        maxGapYearsBelowAge: cfg.maxGapYearsBelowAge ?? null,
        gapAgeThreshold: cfg.gapAgeThreshold ?? null,
      });
    };
    load();
  }, [role?.id, token]);

  useEffect(() => {
    if (location.pathname.includes("/candidates")) setCurrentTab(tabs[0]);
    if (location.pathname.includes("/edit")) setCurrentTab(tabs[1]);
  }, [location.pathname]);

  useEffect(() => {
    if (!token) return;
    getRankType(token).then((res) => {
      const rts = [initialRankType, ...res];
      const rankType = rts.find((r) => r.id === (role?.rankTypeId ?? NIL));
      if (rankType) setRankType(rankType);
    });
  }, [token, role?.rankTypeId]);

  useEffect(() => {
    if (!roleId || !token) return;
    GetRole(roleId, token).then((rl) => {
      setRole(rl);
    });
    GetCities(token).then((c) => {
      setCities(c);
    });
  }, [roleId, token]);

  useEffect(() => {
    if (!roleId || !token) return;
    GetStatusForRole(roleId, token).then((rs) => {
      setStatus(rs);
    });
  }, [roleId, token]);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const isScrollPresent = documentHeight > windowHeight;
      const isAtTop = window.scrollY === 0;
      setScrollToTop(isScrollPresent && !isAtTop);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const handleCreateSlotSubmit = async (
    startTime: Date,
    endTime: Date,
    slotDuration: number,
    breakDuration: number,
    meetingLink: string,
    statusId: string,
    interviewerEmail: string[] | null
  ) => {
    try {
      if (!token) return;
      const res = await createSlots(
        startTime.toISOString(),
        endTime.toISOString(),
        slotDuration,
        breakDuration,
        roleId,
        meetingLink,
        statusId,
        interviewerEmail,
        token
      );
      setErrorMessage(null);
    } catch (err: any) {
      setErrorMessage(err.message);
      notifyError("Error in Creating Slots", err.message || "");
      throw err
    }
  };
  const handleCreatSlotClick = () => {
    setIsCreateSlotOpen(true);
  };
  const handleShowSlotClick = () => {
    setIsShowSlotOpen(true);
  };
  const handleConfigSave = async () => {
    if (!token || !role?.id || !config) return;

    const payload: RoleValidationConfig = {
      roleId: role.id,

      ugMinStartAge: config.ugMinStartAge ?? null,

      ugFirstMaxStartAge: config.ugFirstMaxStartAge ?? null,
      ugMinDurationYears: config.ugMinDurationYears ?? null,
      ugMaxDurationYears: config.ugMaxDurationYears ?? null,
      pgMaxDurationYears: config.pgMaxDurationYears ?? null,
      workMaxStartAge: config.workMaxStartAge ?? null,
      maxGapYears: config.maxGapYears ?? null,

      maxGapYearsBelowAge: config.maxGapYearsBelowAge ?? null,

      gapAgeThreshold: config.gapAgeThreshold ?? null,
    };

    await UpsertRoleValidationConfig(role.id, payload, token);

    setOpenConfigModal(false);
  };
  return (
    <>
      <div className="bg-transparent">
        <div className="flex relative">
          <aside
            className={`dark:border-gray-500 fixed z-10 top-[4.1rem] block h-[calc(100vh-4rem)] left-0 shadow-md border border-gray-200 transition-transform transform duration-200 w-[18rem] ${isSidebarOpen ? "translate-x-0" : "-translate-x-[100%]"
              }`}
          >
            <div
              className={`absolute top-10 z-20 ${isSidebarOpen ? "-right-2 shadow-md" : "-right-4 shadow-xl"
                } h-16 border border-gray-300 rounded-md flex items-center justify-center cursor-pointer bg-white dark:bg-darkbglight dark:border-gray-500 dark:text-gray-300`}
              onClick={() => {
                setIsSideBarOpen(!isSidebarOpen);
              }}
            >
              {isSidebarOpen ? (
                <ChevronDoubleLeftIcon width={16} />
              ) : (
                <ChevronDoubleRightIcon width={16} />
              )}
            </div>
            <div
              className={`h-full bg-white thin-scroll overflow-y-auto dark:bg-darkbg`}
            >
              <RoleSideBarHeader role={role} currentTab={currentTab} />
              {currentTab === "Candidates" ? (
                <RoleSidebarCandidate
                  cities={cities}
                  status={status}
                  rankType={rankType}
                  handleStatusFilterIsAll={(isAll: boolean) => {
                    setStatusFilterIsAll(isAll);
                  }}
                  handleFilterQuery={(query) => {
                    setleftfilter(query);
                  }}
                  handleSearchQuery={(query) => setSearchQuery(query)}
                  setSelectedCol={setSelectedColumns}
                  isShipping={role?.department === "Shipping"}
                />
              ) : (
                role && (
                  <RoleSideBarEdit
                    role={role}
                    toggleConfigModal={() =>
                      setOpenConfigModal((prev) => !prev)
                    }
                  />
                )
              )}
            </div>
          </aside>

          <main
            className={`${!isSidebarOpen && !isRightSidebarOpen
              ? "w-full mx-8"
              : isSidebarOpen
                ? "relative sm:transform sm:translate-x-[18rem] sm:w-[calc(100%-18rem)]"
                : "w-full mx-8"
              } ${isRightSidebarOpen ? "pr-[18rem]" : ""}
  transition-all duration-200 ease-out`}
          >
            {currentTab === "Edit" ? (
              role && <CreateRole />
            ) : (
              <RoleCandidates
                filterQuery={filterQuery}
                searchQuery={searchQuery}
                status={status}
                rankTypeId={rankType.id}
                statusFilterIsAll={statusFilterIsAll}
                handleStatusUpdate={(s) => {
                  setStatus(s);
                }}
                selectedColumns={selectedColumns}
                importEmailListOpen={importEmailListOpen}
                handleImportEmailListOpen={setImportEmailListOpen}
              />
            )}
          </main>
          <aside
            className={`dark:border-gray-500 fixed top-[4.1rem] block h-[calc(100vh-4rem)] right-0 shadow-md border border-gray-200 transition-transform transform duration-200 w-[18rem] ${isRightSidebarOpen ? "translate-x-0" : "translate-x-[100%]"
              }`}
          >
            <div
              className={`absolute top-10  ${isRightSidebarOpen ? "-left-2 shadow-md" : "-left-4 shadow-xl"
                } h-16 border border-gray-300 rounded-md flex items-center justify-center cursor-pointer bg-white dark:bg-darkbglight dark:border-gray-500 dark:text-gray-300`}
              onClick={() => {
                setIsRightSideBarOpen(!isRightSidebarOpen);
              }}
            >
              {isRightSidebarOpen ? (
                <ChevronDoubleRightIcon width={16} />
              ) : (
                <ChevronDoubleLeftIcon width={16} />
              )}
            </div>

            <div className="h-full bg-white thin-scroll overflow-y-auto overflow-x-hidden dark:bg-darkbg">
              <RightSidebar
                handleStatusFilterIsAll={(isAll: boolean) => {
                  setStatusFilterIsAll(isAll);
                }}
                handleFilterQuery={(query) => {
                  setrightfilter(query);
                }}
                handleCreatSlotClick={handleCreatSlotClick}
                handleShowSlotClick={handleShowSlotClick}
                handleImportEmailListClick={() => setImportEmailListOpen(true)}
              />
            </div>
          </aside>
        </div>

        {currentTab === tabs[0] && scrollToTop && (
          <button
            className="bg-entntblue h-6 w-6 rounded-full sticky left-[95%] bottom-14 text-white transform transition-all hover:-translate-y-1"
            onClick={() => {
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });
            }}
          >
            <ChevronDoubleUpIcon />
          </button>
        )}
      </div>
      <SlotModal
        isOpen={isCreateSlotOpen}
        errorText={errorMessage}
        status={status.roleStatuses}
        roleId={roleId}
        token={token}
        onClose={() => {
          setIsCreateSlotOpen(false);
          setErrorMessage(null)
        }}
        onSubmit={handleCreateSlotSubmit}
        onSuccess={() => success("Created Successfully", "Slots has been created successfully")}
      />
      {isShowSlotOpen && (
        <InterviewSlotShow
          isOpen={isShowSlotOpen}
          onClose={() => setIsShowSlotOpen(false)}
          roleId={roleId}
        />
      )}

      <RoleValidationConfigModal
        isOpen={openConfigModal}
        onClose={() => setOpenConfigModal(false)}
        config={config}
        setConfig={setConfig}
        onSave={handleConfigSave}
      />

      {currentTab === tabs[0] && scrollToTop && (
        <button
          className="bg-entntblue h-6 w-6 rounded-full sticky left-[95%] bottom-14 text-white transform transition-all hover:-translate-y-1"
          onClick={() => {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }}
        >
          <ChevronDoubleUpIcon />
        </button>
      )}
    </>
  );
}
